import { render, staticRenderFns } from "./AlarmBreakingNewsItem.vue?vue&type=template&id=3951a21a&scoped=true&"
import script from "./AlarmBreakingNewsItem.vue?vue&type=script&lang=js&"
export * from "./AlarmBreakingNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./AlarmBreakingNewsItem.vue?vue&type=style&index=0&id=3951a21a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951a21a",
  null
  
)

export default component.exports